const styles = theme => ({
  root: {
    maxWidth: '400px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '800px',
    padding: '0px 40px',
    height: '700px',
    maxWidth: '100%',
  },
  box: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    display: 'flex',
    maxWidth: '440px',
  },
  header: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    /* Body/Body 1 */
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    maxWidth: '440px',
  },
  title: {
    color: 'var(--Gray-Darker, #838D98)',
    textAlign: 'center',

    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
    maxWidth: '440px',
  },
})

export default styles
